import { render, staticRenderFns } from "./ChildrenPhysiqueDialog.vue?vue&type=template&id=502d5180&scoped=true&"
import script from "./ChildrenPhysiqueDialog.vue?vue&type=script&lang=js&"
export * from "./ChildrenPhysiqueDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenPhysiqueDialog.vue?vue&type=style&index=0&id=502d5180&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502d5180",
  null
  
)

export default component.exports